export const wishlists = [
  {
    title: "Stays",
    items: [
      {
        title: "Entire serviced classy moutain house",
        priceOld: "$356",
        priceActual: "$267",
        categoryText: "superhost",
        rating: "4.8",
        reviews: "12",
        cost: "$200 total",
        src: "/images/content/card-pic-1.jpg",
        srcSet: "/images/content/card-pic-1@2x.jpg",
        url: "/stays-product",
        options: [
          {
            title: "Free wifi",
            icon: "modem",
          },
          {
            title: "Breakfast included",
            icon: "burger",
          },
        ],
      },
      {
        title: "Entire serviced classy moutain house",
        priceOld: "$245",
        priceActual: "$167",
        categoryText: "superhost",
        rating: "4.9",
        reviews: "24",
        cost: "$100 total",
        src: "/images/content/card-pic-2.jpg",
        srcSet: "/images/content/card-pic-2@2x.jpg",
        url: "/stays-product",
        options: [
          {
            title: "Free wifi",
            icon: "modem",
          },
          {
            title: "Breakfast included",
            icon: "burger",
          },
        ],
      },
      {
        title: "Entire serviced classy moutain house",
        priceOld: "$356",
        priceActual: "$267",
        categoryText: "superhost",
        rating: "5.0",
        reviews: "102",
        cost: "$333 total",
        src: "/images/content/card-pic-3.jpg",
        srcSet: "/images/content/card-pic-3@2x.jpg",
        url: "/stays-product",
        options: [
          {
            title: "Free wifi",
            icon: "modem",
          },
          {
            title: "Breakfast included",
            icon: "burger",
          },
        ],
      },
      {
        title: "Entire serviced classy moutain house",
        priceOld: "$156",
        priceActual: "$267",
        categoryText: "superhost",
        rating: "4.5",
        reviews: "5",
        cost: "$230 total",
        src: "/images/content/card-pic-4.jpg",
        srcSet: "/images/content/card-pic-4@2x.jpg",
        url: "/stays-product",
        options: [
          {
            title: "Free wifi",
            icon: "modem",
          },
          {
            title: "Breakfast included",
            icon: "burger",
          },
        ],
      },
      {
        title: "Entire serviced classy moutain house",
        priceOld: "$556",
        priceActual: "$267",
        categoryText: "superhost",
        rating: "4.8",
        reviews: "12",
        cost: "$200 total",
        src: "/images/content/card-pic-5.jpg",
        srcSet: "/images/content/card-pic-5@2x.jpg",
        url: "/stays-product",
        options: [
          {
            title: "Free wifi",
            icon: "modem",
          },
          {
            title: "Breakfast included",
            icon: "burger",
          },
        ],
      },
      {
        title: "Entire serviced classy moutain house",
        priceOld: "$322",
        priceActual: "$207",
        categoryText: "superhost",
        rating: "4.8",
        reviews: "12",
        cost: "$300 total",
        src: "/images/content/card-pic-6.jpg",
        srcSet: "/images/content/card-pic-6@2x.jpg",
        url: "/stays-product",
        options: [
          {
            title: "Free wifi",
            icon: "modem",
          },
          {
            title: "Breakfast included",
            icon: "burger",
          },
        ],
      },
    ],
  },
  {
    title: "Flights",
    items: [
      {
        price: "$3,256",
        info: "eDreams",
        directions: [
          {
            flightFrom: "AKL",
            flightTo: "SGN",
            timeFlightFrom: "6:45 AM",
            timeFlightTo: "9:45 AM",
            logo: "/images/content/emirates.svg",
          },
          {
            flightFrom: "SGN",
            flightTo: "AKL",
            timeFlightFrom: "12:45 AM",
            timeFlightTo: "3:45 AM",
            logo: "/images/content/emirates.svg",
          },
        ],
      },
      {
        price: "$3,256",
        info: "eDreams",
        directions: [
          {
            flightFrom: "AKL",
            flightTo: "SGN",
            timeFlightFrom: "6:45 AM",
            timeFlightTo: "9:45 AM",
            logo: "/images/content/emirates.svg",
          },
          {
            flightFrom: "SGN",
            flightTo: "AKL",
            timeFlightFrom: "12:45 AM",
            timeFlightTo: "3:45 AM",
            logo: "/images/content/emirates.svg",
          },
        ],
      },
      {
        price: "$3,256",
        info: "eDreams",
        directions: [
          {
            flightFrom: "AKL",
            flightTo: "SGN",
            timeFlightFrom: "6:45 AM",
            timeFlightTo: "9:45 AM",
            logo: "/images/content/emirates.svg",
          },
          {
            flightFrom: "SGN",
            flightTo: "AKL",
            timeFlightFrom: "12:45 AM",
            timeFlightTo: "3:45 AM",
            logo: "/images/content/emirates.svg",
          },
        ],
      },
      {
        price: "$3,256",
        info: "eDreams",
        directions: [
          {
            flightFrom: "AKL",
            flightTo: "SGN",
            timeFlightFrom: "6:45 AM",
            timeFlightTo: "9:45 AM",
            logo: "/images/content/emirates.svg",
          },
          {
            flightFrom: "SGN",
            flightTo: "AKL",
            timeFlightFrom: "12:45 AM",
            timeFlightTo: "3:45 AM",
            logo: "/images/content/emirates.svg",
          },
        ],
      },
    ],
  },
  {
    title: "Cars",
    items: [
      {
        title: "London - Kings Cross",
        priceOld: "/day",
        priceActual: "$300",
        category: "white",
        categoryText: "popular",
        rating: "4.8",
        reviews: "12",
        cost: "$1000 total",
        src: "/images/content/cars-pic-1.jpg",
        srcSet: "/images/content/cars-pic-1@2x.jpg",
        url: "/cars-product",
        options: [
          {
            title: "London - Kings Cross",
            icon: "route",
          },
        ],
      },
      {
        title: "London - Kings Cross",
        priceOld: "/day",
        priceActual: "$420",
        category: "white",
        categoryText: "popular",
        rating: "4.9",
        reviews: "20",
        cost: "$1100 total",
        src: "/images/content/cars-pic-2.jpg",
        srcSet: "/images/content/cars-pic-2@2x.jpg",
        url: "/cars-product",
        options: [
          {
            title: "London - Kings Cross",
            icon: "route",
          },
        ],
      },
      {
        title: "London - Kings Cross",
        priceOld: "/day",
        priceActual: "$300",
        category: "white",
        categoryText: "popular",
        rating: "4.5",
        reviews: "120",
        cost: "$700 total",
        src: "/images/content/cars-pic-3.jpg",
        srcSet: "/images/content/cars-pic-3@2x.jpg",
        url: "/cars-product",
        options: [
          {
            title: "London - Kings Cross",
            icon: "route",
          },
        ],
      },
    ],
  },
  {
    title: "Thing to do",
    items: [
      {
        title: "Premium milford sound tour ex Queenstown",
        priceOld: "$524",
        priceActual: "$444",
        category: "white",
        categoryText: "popular",
        rating: "5.0",
        reviews: "24",
        avatar: "/images/content/avatar-2.jpg",
        comment:
          "The best 16 passenger small group, intimate and unique, Milford Sound...",
        cost: "$600 total",
        src: "/images/content/card-pic-6.jpg",
        srcSet: "/images/content/card-pic-6@2x.jpg",
        url: "/product",
        options: [
          {
            title: "12 hours",
            icon: "clock",
          },
          {
            title: "Up to 7 people",
            icon: "user",
          },
        ],
      },
      {
        title: "Premium milford sound tour ex Queenstown",
        priceOld: "$300",
        priceActual: "$250",
        rating: "4.5",
        reviews: "14",
        avatar: "/images/content/avatar-3.jpg",
        comment:
          "The best 16 passenger small group, intimate and unique, Milford Sound...",
        cost: "$300 total",
        src: "/images/content/card-pic-7.jpg",
        srcSet: "/images/content/card-pic-7@2x.jpg",
        url: "/product",
        options: [
          {
            title: "12 hours",
            icon: "clock",
          },
          {
            title: "Up to 20 people",
            icon: "user",
          },
        ],
      },
      {
        title: "Premium milford sound tour ex Queenstown",
        priceOld: "$524",
        priceActual: "$444",
        rating: "5.0",
        reviews: "143",
        avatar: "/images/content/avatar-4.jpg",
        comment:
          "The best 16 passenger small group, intimate and unique, Milford Sound...",
        cost: "$200 total",
        src: "/images/content/card-pic-8.jpg",
        srcSet: "/images/content/card-pic-8@2x.jpg",
        url: "/product",
        options: [
          {
            title: "12 hours",
            icon: "clock",
          },
          {
            title: "Up to 10 people",
            icon: "user",
          },
        ],
      },
    ],
  },
];
